import dateformat from 'dateformat';

const CURRENCY_FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0
  // the default value for minimumFractionDigits depends on the currency
  // and is usually already 2
});

class StringFormatter {
  static formatCurrency(price) {
    return CURRENCY_FORMATTER.format(price);
  }

  static formatLongDate(date) {
    return dateformat(date, 'd mmmm yyyy');
  }

  static formatShortDate(date) {
    return dateformat(date, 'dd-mmm');
  }

  static formatDateIgnoreTimeZone(date, format) {
    // temporary solution, cuts info about timezone
    return dateformat(date.split('.')[0], format);
  }
}

export { StringFormatter };



// WEBPACK FOOTER //
// ./src/utils/StringFormatter.js